/**
 * @author caijianjia
 * @date 2020/3/23 9:07 下午
 */

import request from '../config/network/requestUcenterApiService'
// import request from '../config/network/requestMockApiService'

/**
 * 分类管理
 */

// 新建分类
export function addCourseType ({
  clientsId,
  parentId = 0,
  levelsId = 0,
  name,
  image,
  description,
  ...params
}) {
  return request({
    url: `api/courseware/category?clients_id=${clientsId}`,
    method: 'post',
    data: {
      parent_id: parentId,
      levels_id: levelsId,
      name,
      image,
      description,
      ...params
    }
  })
}

// 删除分类
export function deleteCourseType ({ id, clientsId }) {
  return request({
    url: `api/courseware/category/${id}`,
    method: 'delete',
    data: { clients_id: clientsId }
  })
}

// 修改分类
export function updateCourseType ({
  id,
  clientsId,
  parentId = 0,
  levelsId = 0,
  name,
  image,
  description
}) {
  return request({
    url: `api/courseware/category/${id}`,
    method: 'put',
    data: {
      clients_id: clientsId,
      parent_id: parentId,
      levels_id: levelsId,
      name,
      image,
      description
    }
  })
}

// 获取分类列表
export function getCourseTypeList ({
  search,
  parentId = 0,
  clientsId,
  ...params
}) {
  let url = 'api/courseware/category'
  if (search) {
    url += `?like[name]=${search}`
  }
  return request({
    url,
    method: 'get',
    params: { clients_id: clientsId, 'equal[parent_id]': parentId, ...params }
  })
}

// 获取规则列表
export function getCourseRuleList ({
  parentId = 0,
  clientsId,
  ...params
}) {
  return request({
    url: 'api/courseware/category/tree',
    method: 'get',
    params: { clients_id: clientsId, top_id: parentId, ...params }
  })
}

// 获取分类详情
export function getCourseTypeDetail ({ id }) {
  return request({
    url: `api/courseware/category/${id}`,
    method: 'get'
  })
}

/**
 * 等级管理
 */

// 新建等级
export function addCourseGrade ({ clientsId, categoryId, name, ...params }) {
  return request({
    url: `api/courseware/levels?clients_id=${clientsId}`,
    method: 'post',
    data: { category_id: categoryId, name, ...params }
  })
}

// 删除等级
export function deleteCourseGrade ({ id, clientsId }) {
  return request({
    url: `api/courseware/levels/${id}?clients_id=${clientsId}`,
    method: 'delete'
  })
}

// 修改等级
export function updateCourseGrade ({
  id,
  clientsId,
  categoryId,
  name,
  ...params
}) {
  return request({
    url: `api/courseware/levels/${id}`,
    method: 'put',
    data: { clients_id: clientsId, category_id: categoryId, name, ...params }
  })
}

// 等级列表
export function getCourseGradeList ({ clientsId, parentId }) {
  return request({
    url: `api/courseware/levels?clients_id=${clientsId}`,
    method: 'get',
    params: { 'equal[parent_id]': parentId }
  })
}

// 等级详情
export function getCourseGradeDetail ({ id, clientsId }) {
  return request({
    url: `api/courseware/levels/${id}?clients_id=${clientsId}`,
    method: 'get'
  })
}
